var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconIntersect = function SvgIconIntersect(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.25 9a7.75 7.75 0 0 0 6.163 7.587 7.75 7.75 0 1 0 9.175-9.175A7.75 7.75 0 0 0 1.25 9M9 3.25a5.75 5.75 0 0 0-1.733 11.234 7.75 7.75 0 0 1 7.217-7.217A5.75 5.75 0 0 0 9 3.25M20.75 15a5.75 5.75 0 0 0-4.017-5.484 7.75 7.75 0 0 1-7.217 7.217A5.75 5.75 0 0 0 20.75 15m-8.453-1.289a5.7 5.7 0 0 1-3.041 1.033 5.7 5.7 0 0 1 1.033-3.041zm1.415-1.414-2.009-2.009a5.7 5.7 0 0 1 3.041-1.032 5.7 5.7 0 0 1-1.032 3.04",
    clipRule: "evenodd"
  })));
};
export default SvgIconIntersect;